import script from "./FinalizationEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalizationEditor.vue?vue&type=script&setup=true&lang=ts"

import "./FinalizationEditor.vue?vue&type=style&index=0&id=355a82e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355a82e6"]])

export default __exports__